import styled, { css } from 'styled-components';
import arrowLeft from 'assets/images/arrow-left.svg';
import arrowLeft2 from 'assets/images/arrow-left-2.svg';
import arrowRight from 'assets/images/arrow-right.svg';
import play from 'assets/images/play.svg';
import { fonts } from 'styles';

interface ModalPros {
  isOpen: boolean;
}

export const Modal = styled.div<ModalPros>`
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  display: none;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #070707;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 99;

  ${({ isOpen }) =>
    isOpen &&
    css`
      display: flex;
      animation: appear 300ms ease;

      @keyframes appear {
        0% {
          opacity: 0;
        }
        100% {
          opacity: 1;
        }
      }
    `};
`;

export const Container = styled.div`
  width: 100%;
  height: auto;
  margin: 0 auto;
  padding: 56px;
  .slick-prev:before,
  .slick-next:before {
    content: '';
    display: none;
  }
  position: relative;
`;

export const ArrowLeft = styled.img.attrs({ src: arrowLeft })``;

export const ArrowRight = styled.img.attrs({ src: arrowRight })``;

export const Button = styled.button.attrs({ type: 'button' })`
  position: absolute;
  z-index: 99;
  top: calc(50% - 56px);
  transition: 300ms ease;
  z-index: 99;

  &:hover {
    transform: scale(1.1);
  }

  &.left {
    left: 56px;
  }

  &.right {
    right: 56px;
  }

  @media screen and (max-width: 1366px) {
    &.left {
      left: 32px;
    }
    &.right {
      right: 32px;
    }
  }
  @media screen and (max-width: 1280px) {
    &.left {
      left: 16px;
    }
    &.right {
      right: 16px;
    }
  }
`;

export const Album = styled.div`
  display: flex !important;
  column-gap: 56px;
  width: 100%;
  max-width: 1160px;
  margin: 0 auto;
`;

export const AlbumContent = styled.div`
  flex: 1;
`;

export const AlbumHeader = styled.header`
  display: flex;
  column-gap: 24px;
  margin-bottom: 40px;

  div.wrapper {
    flex: 1;
  }
`;

export const AlbumYear = styled.div`
  font-family: ${fonts.BentonSansMedium};
  font-size: 25px;
  line-height: 50px;
  color: #fff;
  text-align: center;
  background-color: #0861f5;
  width: 60px;
  height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;

  span {
    display: block;
    font-size: 12px;
    line-height: 24px;
  }
`;

export const AlbumArtist = styled.span`
  display: block;
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  margin-bottom: 16px;
`;

export const AlbumTitle = styled.h2`
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 20px;
  line-height: 22px;
  color: #fff;
  text-transform: uppercase;
`;

export const AlbumCoverWrapper = styled.div``;

export const AlbumCover = styled.img`
  width: 100%;
  max-width: max-content;
  margin-bottom: 40px;
`;

export const AlbumDescription = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 24px;
  color: #fff;
  margin-bottom: 40px;
  height: 392px;
  overflow-y: auto;

  ::-webkit-scrollbar {
    width: 4px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background: #ffffff50;
    border-radius: 2px;
  }

  p {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const PlayIcon = styled.img.attrs({ src: play })`
  transition: 300ms ease;
`;

export const PlayButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  column-gap: 16px;
  color: #fff;
  font-family: ${fonts.BentonSansWideBlack};
  font-size: 14px;
  line-height: 18px;
  text-transform: uppercase;
  text-align: left;

  &:hover {
    ${PlayIcon} {
      transform: scale(1.1);
    }
  }
`;

export const BackButton = styled.button.attrs({ type: 'button' })`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
  color: #111;
  font-family: ${fonts.BentonSansMedium};
  text-transform: uppercase;
  padding: 12px 20px;
  border-radius: 20px;
  position: absolute;
  bottom: 46px;
  left: calc(50% - 56px);
  z-index: 99;
  transition: 300ms ease;

  &:hover {
    transform: scale(1.1);
  }
`;

export const ArrowLeft2 = styled.img.attrs({ src: arrowLeft2 })`
  margin-right: 12px;
`;
